import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import {
  BooleanFilterOption,
  FilterBoxTypes,
} from '@/src/components/common/FilterBox/V2/FilterBox';
import ShadowedCard from '@/src/components/myTasks/MyPortfolio/Elements/ShadowedCard/ShadowedCard';
import { MyPortfolioColumnsEnum } from '@/src/components/myTasks/MyPortfolio/types';

import { getFilterOption, useMyPortfolio } from '../../../../../store/myPortfolio.store';
import FiltertableHeaderItem from '../../Header/HeaderItem/FilterableHeaderItem';
import { ColumnOption } from '../Table';

type MilestoneHeaderProps = {
  filterOption: BooleanFilterOption;
};

const MilestoneHeader = ({ filterOption }: MilestoneHeaderProps) => {
  const { updateFilterOptions } = useMyPortfolio();

  const handleUpdateFilters = () => {
    updateFilterOptions({
      columnKey: MyPortfolioColumnsEnum.IsMilestone,
      filterOption: {
        ...filterOption,
        isActive: !filterOption.isActive,
      },
    });
  };

  return (
    <Button onClick={handleUpdateFilters} className={'tw-p-0 tw-pr-[5px] tw-m-0'}>
      <i
        className={clsx(
          !filterOption.isActive && 'tw-text-cfo-black',
          filterOption.isActive && 'tw-text-[rgba(80,129,255,1)]',
          'material-icons milestoneIcon  hover:tw-text-[rgba(80,129,255,1)]'
        )}
      >
        {filterOption.isActive ? 'flag' : 'outlined_flag'}
      </i>
    </Button>
  );
};

const TaskNameSkeleton = ({ title }: { title: string }) => {
  return (
    <ShadowedCard className="tw-w-full tw-absolute tw-top-0 tw-left-0 tw-h-full tw-py-[20px] tw-px-[10px] tw-bg-white">
      <div className="tw-w-full tw-flex tw-pl-[45px]">
        {/* <i className={clsx('tw-text-cfo-black')}>outlined_flag</i> */}
        <span className="">{title}</span>
      </div>
    </ShadowedCard>
  );
};

type TaskNameHeaderProps = {
  column: ColumnOption;
};

const TaskNameHeader = ({ column }: TaskNameHeaderProps) => {
  const { filterOptions } = useMyPortfolio();

  if (!filterOptions) {
    return <TaskNameSkeleton title={column.title} />;
  }

  const milestFilterOption = getFilterOption(filterOptions, MyPortfolioColumnsEnum.IsMilestone);

  if (milestFilterOption.type !== FilterBoxTypes.Boolean) {
    return <TaskNameSkeleton title={column.title} />;
  }

  return (
    <React.Fragment>
      <ShadowedCard className="tw-w-full tw-absolute tw-top-0 tw-left-0 tw-h-full tw-py-[20px] tw-px-[10px] tw-bg-white">
        <div className="tw-w-full tw-flex tw-pl-[45px]">
          <MilestoneHeader filterOption={milestFilterOption} />
          <FiltertableHeaderItem column={column} />
        </div>
      </ShadowedCard>
    </React.Fragment>
  );
};

export default TaskNameHeader;
